<template>
  <p class="pl-4 text-sm text-left text-gray-700" :class="price ? 'text-right pr-4' : ''">
    <span v-html="highlightedText"></span>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  header: string;
  item: string | undefined | number;
  searchQuery: string;
  price?: boolean;
}>();

const formatItem = computed(() => {
  if (props.item == null || props.item == undefined) return null;
  if (props.price) {
    const num = typeof props.item === 'number' ? props.item : Number(props.item);
    return Number.isFinite(num) ? num.toFixed(2) : String(props.item);
  }
  return String(props.item);
});

const highlightedText = computed(() => {
  const text = formatItem.value;
  if (text === null) return '-';
  if (!props.searchQuery) return text;

  const regex = new RegExp(`(${props.searchQuery})`, 'gi');
  return String(text).replace(regex, '<span class="py-0.5 pl-0.5 bg-blue-100">$1</span>');
});
</script>
